// Pizza no pedido, igual ao cardápio digital (dono, 25/10/2026): Mesas, Comandas
// e Balcão gravam e imprimem a pizza do mesmo jeito que o cardápio, que já
// funciona — sabores ("1/2 Calabresa"), borda e adicionais vão em `subitems`
// (o cupom lê dali) e tamanho/sabores/borda vão em `pizza_meta` (o backend
// confere o preço com a mesma conta do popup).

/** `pizza_meta` do item do carrinho (o `pizza` que o PizzaPopup monta), no formato do cardápio. */
export function pizzaMetaDoItem(item) {
  const p = item?.pizza || item?.pizza_meta;
  if (!p || typeof p !== "object") return null;
  return {
    size_id: p.size_id,
    size_name: p.size_name,
    flavor_ids: p.flavor_ids || [],
    border_id: p.border_id || null,
    border_name: p.border_name || null,
    pricing_rule: p.pricing_rule || null,
  };
}

/**
 * Subitens do item para o pedido e o cupom. Item com etapas: os montados das
 * etapas (`dasEtapas`). Pizza não tem etapas — os sabores e a borda já vêm
 * prontos do popup em `item.subitems`; sem este recuo eles sumiam.
 */
export function subitemsComPizza(item, dasEtapas) {
  if (Array.isArray(dasEtapas) && dasEtapas.length) return dasEtapas;
  return Array.isArray(item?.subitems) && item.subitems.length ? item.subitems : [];
}
